import * as React from "react";
import {useTranslation} from "react-i18next";
import styles from "./AdvantagesBanner.module.scss";
import {getShopId} from "../getShopId";

const AdvantagesBanner: React.FC = () => {
  const {t} = useTranslation(["cart"]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.listWrapper}>
        <ul>
          <li>
            {t("30 Tage Rückgaberecht")}
            {getShopId() === 100005 && <>&#160;**</>}
          </li>
          <li>
            {t("Kostenlose Retouren bei Paketware")}
            {getShopId() === 100005 && <>&#160;**</>}
          </li>
          <li>{t("Klimaneutraler Versand")}</li>
          <li>
            <span>&#160;</span>
          </li>
        </ul>
      </div>
      <span className={styles.gradient}>&#160;</span>
    </div>
  );
};

export default AdvantagesBanner;
